module.exports = __webpack_public_path__ + "img/icon_miniApp_code.c032abf4.jpg";